// Service to manage credit card options from API
const isDev = process.env.NODE_ENV === 'development';
const BASE = isDev ? '' : (process.env.REACT_APP_API_BASE_URL || '');
const CREDIT_CARD_OPTIONS_ENDPOINT = BASE ? `${BASE.replace(/\/$/, '')}/api/cards` : '/api/cards';

function getBasicAuthHeader() {
    const user = process.env.REACT_APP_API_USER ||
        (typeof window !== 'undefined' && window.localStorage.getItem('REACT_APP_API_USER'));
    const pass = process.env.REACT_APP_API_PASSWORD ||
        (typeof window !== 'undefined' && window.localStorage.getItem('REACT_APP_API_PASSWORD'));

    if (user && pass) {
        let encoded;
        if (typeof window !== 'undefined' && window.btoa) {
            encoded = window.btoa(`${user}:${pass}`);
        } else if (typeof Buffer !== 'undefined') {
            encoded = Buffer.from(`${user}:${pass}`).toString('base64');
        }
        return `Basic ${encoded}`;
    }
    return undefined;
}

const getHeaders = () => {
    const headers = { 'Content-Type': 'application/json' };
    // Always include Basic Auth for Spring Security
    const auth = getBasicAuthHeader();
    if (auth) headers['Authorization'] = auth;
    return headers;
};

// Fetch all credit card options
export const fetchCreditCardOptions = async () => {
    try {
        const response = await fetch(CREDIT_CARD_OPTIONS_ENDPOINT, {
            method: 'GET',
            headers: getHeaders()
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching credit card options:', error);
        throw error;
    }
};

// Create a new credit card option
export const createCreditCardOption = async (option) => {
    try {
        const response = await fetch(CREDIT_CARD_OPTIONS_ENDPOINT, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(option)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating credit card option:', error);
        throw error;
    }
};

// Update a credit card option
export const updateCreditCardOption = async (id, option) => {
    try {
        const response = await fetch(`${CREDIT_CARD_OPTIONS_ENDPOINT}/${id}`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(option)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating credit card option:', error);
        throw error;
    }
};

// Delete a credit card option
export const deleteCreditCardOption = async (id) => {
    try {
        const response = await fetch(`${CREDIT_CARD_OPTIONS_ENDPOINT}/${id}`, {
            method: 'DELETE',
            headers: getHeaders()
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    } catch (error) {
        console.error('Error deleting credit card option:', error);
        throw error;
    }
};
